import React from "react";
import { Box, keyframes, Typography, useTheme } from "@mui/material";

const ringPulse = keyframes`
  0% { transform: scale(0.8); opacity: 0.6; }
  100% { transform: scale(2); opacity: 0; }
`;

export default function Logo({ onClick }) {
  const theme = useTheme();

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.2,
        cursor: "pointer",
        position: "relative",
        userSelect: "none",
      }}
    >
      {[0, 1.6].map((delay, i) => (
        <Box
          component="span"
          key={i}
          sx={{
            position: "absolute",
            right: 18,
            top: "50%",
            width: 34,
            height: 34,
            marginTop: "-17px",
            borderRadius: "50%",
            border: `1.5px solid ${i === 0 ? theme.palette.info.main : theme.palette.secondary.main}`,
            pointerEvents: "none",
            animation: `${ringPulse} 3.2s ease-out ${delay}s infinite`,
            willChange: "transform, opacity",
          }}
        />
      ))}

      <Typography
        fontFamily="YekanPlus"
        fontWeight={800}
        fontSize={19}
        color="primary.main"
        lineHeight={1}
      >
        راما
      </Typography>

      <Box
        sx={{
          width: 34,
          height: 34,
          position: "relative",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "transform 0.6s ease-in-out",
          "&:hover": {
            transform: "rotate(360deg)",
          },
        }}
      >
        <Box
          component="img"
          src="/Media/Layout/MainLayout/Navbar/nobgImage-34.webp"
          alt="لوگوی راما"
          width={34}
          height={19}
          sx={{
            width: "34px",
            height: "19px",
            objectFit: "contain",
          }}
        />
      </Box>
    </Box>
  );
}
